export enum ProductionImportOverridesRoutes {
  OverrideDefinition = 'override-definition',
  OverrideAssignment = 'override-assignment',
  ReportTemplates = 'report-templates',
  OverrideReportingSessions = 'override-reporting-sessions',
}

export interface ProductionImportOverridesNavItem {
  id: ProductionImportOverridesRoutes;
  text: string;
  width: number;
}

export const PRODUCTION_IMPORT_OVERRIDES_API_PATHS = {
  overrideDefinition: '',
  overrideAssignments: 'agencies',
  overrideProducts: 'products',
  overrideCarriers: 'carriers',
  fields: '/fields',
} as const;

export const PRODUCTION_IMPORT_OVERRIDES_NAV_ITEMS: ProductionImportOverridesNavItem[] = [
  { id: ProductionImportOverridesRoutes.OverrideReportingSessions, text: 'Reporting Sessions', width: 160 },
  { id: ProductionImportOverridesRoutes.OverrideDefinition, text: 'Definitions', width: 160 },
  { id: ProductionImportOverridesRoutes.OverrideAssignment, text: 'Agency Mapping', width: 160 },
  { id: ProductionImportOverridesRoutes.ReportTemplates, text: 'Report Templates', width: 160 },
];
